import $ from "jquery";
import ajax from "ajax";
import Bacon from "Bacon";
import login from "login";
import c from "common";
import formHelpers from "form-helpers";
import translate from "translate";

var $body = $(document.body);

function toggleCouponsList() {
  var $coupons = $('.elisa-navi__login .coupons');
  if ($coupons.attr('data-group-count') > 1) {
    $coupons.toggleClass("expanded");
    $coupons.find('ul').css('height', $coupons.hasClass("expanded") ? $('.elisa-navi__login .coupons ul li').length * 40 : 0);
  }
}

function toggleActivationCode() {
  $('.elisa-navi__login .activation-code').toggleClass("expanded");
}

function getCouponData() {
  return [].slice.call(document.querySelectorAll('.elisa-navi__login .coupons li'), 0).map(mapCouponElement);
}

function mapCouponElement(element) {
  var $element = $(element);
  var $expiration = $element.find('.expiration');
  return {
    couponCount: c.asInt($element.attr('data-count')) || 0,
    couponValidString: $expiration.attr('data-validstring'),
    couponDate: $expiration.attr('data-validuntil')
  };
}

function couponCount(user) {
  return user.coupons && user.coupons.couponCount ? user.coupons.couponCount : 0;
}

function couponGroups(user) {
  return user.coupons && user.coupons.couponGroups ? user.coupons.couponGroups : [];
}

function userWithCoupons() {
  var user = login.fromDOM();
  var $coupons = $('.user-options-container .coupons');
  if ($coupons.length > 0) {
    user.coupons = {
      couponGroups: getCouponData(),
      couponCount: c.asInt($coupons.attr('data-count')) || 0,
      groupCount: c.asInt($coupons.attr('data-group-count')) || 0
    };

    user.coupons.firstExpiration = user.coupons.couponGroups[0].couponValidString;
    user.coupons.firstCount = user.coupons.couponGroups[0].couponCount;
  }
  return user;
}

function getCouponCodeInputElement() {
  return $('.modal .activation-code input[name="code"]');
}

function redeemRequest($target) {
  return {
    url: "/api/user/activate-coupon",
    data: $target.serialize(),
    type: "POST",
    dataType: "html"
  };
}

function getParent($target) {
  return $target.parent();
}

$body.asEventStream("click", ".expandCoupons").doAction(c.stopEvent).onValue(toggleCouponsList);
$body.asEventStream("click", ".elisa-navi__login .activation-code h3").doAction(c.stopEvent).onValue(toggleActivationCode);

formHelpers.bubbleHover(".activation-code .error", translate("invalid-activation-code"));

var modalActicationCodeSubmission = $body.asEventStream("click", ".redeem-coupon-button").map(getCouponCodeInputElement);
var activationCodeForm = $body.asEventStream("submit", ".elisa-navi__login .activation-code form").doAction(".preventDefault").map(c.$target);
var modalRedeemRequest = modalActicationCodeSubmission.map(redeemRequest).flatMap(ajax.stream);
var modalActivationCodeFormContainer = modalActicationCodeSubmission.map(getParent);
var activationCodeStream = activationCodeForm.flatMap(ajax.ajaxify).merge(modalRedeemRequest).flatMap(login.reload);
var activationCodeForms = activationCodeForm.merge(modalActivationCodeFormContainer);
Bacon.zipAsArray(activationCodeStream.map(false).mapError(true), activationCodeForms).onValues(formHelpers.toggleError);
activationCodeStream.onValue(toggleCouponsList);
Bacon.onValues(activationCodeForms, activationCodeForms.awaiting(activationCodeStream.mapError(true)), formHelpers.toggleProgress);

var user = login.userStream.toProperty(userWithCoupons());
user.onValue(function () {
}); // make property active

export default {
  userWithCoupons: user,
  count: user.map(couponCount),
  groups: user.map(couponGroups)
};



// WEBPACK FOOTER //
// ./web/js/coupons.js